import React from 'react';

export default function AgentMark({ agent, size = 'md' }) {
  if (!agent) return null;
  const cls = size === 'lg' ? 'agent-mark lg' : size === 'xs' ? 'agent-mark xs' : 'agent-mark';
  return (
    <span className={cls} style={{ '--m': agent.mark }}>
      {agent.glyph}
    </span>
  );
}
